import barba from '@barba/core';
export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        });
        // const addJs = document.querySelector('#js-ad');
        // if(addJs) {
        //     addJs.addEventListener('load', () => {
        //         this.init();
        //     })
        // }
        barba.hooks.after((data) => {
            this.init()
        });
	}
    init() {
        const ads = document.querySelectorAll('.adsbygoogle');
        if(ads.length > 0) {
            ads.forEach(function (ad) {
                if (ad.firstChild) {
                    ad.removeChild(ad.firstChild);
                }
            });
            window.adsbygoogle = window.adsbygoogle || [];
            window.adsbygoogle.push({});
        }
    }
}